"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionThreeV2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var section_3_png_1 = __importDefault(require("@static/img/png/section-3.png"));
var Button_1 = __importDefault(require("../../../../components/Button"));
var icons_1 = require("../../../../utils/icons");
var styles_1 = require("./styles");
var arrayCardsThree = [
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconSecurity, {}),
        arcColor: 'cyan',
        title: 'Seguridad de Nivel Superior ',
        paragraph: 'Reduce fraudes, protege los datos de tus clientes con nuestra pasarela de pagos con los estándares de PCI DSS.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconPaymentMethod, {}),
        arcColor: 'purple',
        title: 'Métodos de Pago',
        paragraph: 'Acepta tarjetas de crédito y débito Visa y Master Card',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconEasyUse, {}),
        arcColor: 'blue',
        title: 'Facilidad de uso',
        paragraph: 'Automatiza procesos, configura fácil y sin complicaciones nuestra pasarela de pagos.',
    },
    {
        icon: (0, jsx_runtime_1.jsx)(icons_1.IconFastClock, {}),
        arcColor: 'blue',
        title: 'Rápido y Confiable',
        paragraph: 'Procesamos operaciones de tus clientes sin demoras ni problemas, además te damos soporte 100% personalizado.',
    },
];
function SectionThreeV2(_a) {
    var navigator = (0, react_router_dom_1.useNavigate)();
    return ((0, jsx_runtime_1.jsx)(styles_1.Container, { children: (0, jsx_runtime_1.jsxs)(styles_1.ContainerThree, { children: [(0, jsx_runtime_1.jsx)(styles_1.ContainerThreeLeft, { children: (0, jsx_runtime_1.jsxs)(styles_1.ContentWrapper, { children: [(0, jsx_runtime_1.jsx)(styles_1.SectionTitle, __assign({ className: "three" }, { children: "Pasarela de pagos GBC" })), (0, jsx_runtime_1.jsx)(styles_1.ContainerPaymentFeatureCards, { children: arrayCardsThree.map(function (card, index) { return ((0, jsx_runtime_1.jsxs)(styles_1.PaymentFeatureCard, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "icon-wrapper" }, { children: card.icon })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h4", { children: card.title }), (0, jsx_runtime_1.jsx)(styles_1.Paragraph, { children: card.paragraph })] })] }, index)); }) }), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ color: "purple", onClick: function () { return navigator('/payment-gateway'); } }, { children: "Conoce m\u00E1s" }))] }) }), (0, jsx_runtime_1.jsx)(styles_1.ContainerThreeImg, { src: section_3_png_1.default, alt: "image" })] }) }));
}
exports.SectionThreeV2 = SectionThreeV2;
